import { v7 as uuidv7, validate as validateUuid, version as uuidVersion } from 'uuid';

/**
 * システムコード（UUID v7）の払い出し（02 0.4・9.1、要件書 9.2）。
 * UUID はこの関数以外で作らない（02 11.2 No.7）。
 */
export function issueSystemCode(): string {
  return uuidv7();
}

/** UUID v7 の形か（zSystemCode の補助） */
export function isSystemCode(value: string): boolean {
  return validateUuid(value) && uuidVersion(value) === 7;
}
